import DashboardPromo, { DashboardPromoSkeleton } from './DashboardPromo';

export default DashboardPromo;
export { DashboardPromoSkeleton };
export * from './DashboardPromoProps';
